var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from 'react';
import { LeftVoteResultBlock, RightVoteResultBlock, VoteResultWrapper } from './styles';
import { LayoutConst, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE } from '../../../../../constants/media';
import { FInter, FlexBox, useBreakpoint } from '@brg/ui';
import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import { localizeTitle } from "./voteradioblock";
import useLocalization from "../../../../../hooks/useLocalization";
export var MORE_COLOR = '#00BE00';
export var LESS_COLOR = '#E40000';
export var ResultLabel = styled(FInter.SmallTextBold)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: 'Inter';\n  width: 100%;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 42px;\n  line-height: 48px;\n  color: #fff;\n  white-space: wrap;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    font-size: 29px;\n    line-height: 39.5px;\n  }\n\n  @media(max-width: ", "px) {\n    font-size: 22px;\n    line-height: 28px;\n  }\n\n  @media(max-width: ", "px) {\n    font-size: 17px;\n    line-height: 22px;\n  }\n"], ["\n  font-family: 'Inter';\n  width: 100%;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 42px;\n  line-height: 48px;\n  color: #fff;\n  white-space: wrap;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    font-size: 29px;\n    line-height: 39.5px;\n  }\n\n  @media(max-width: ", "px) {\n    font-size: 22px;\n    line-height: 28px;\n  }\n\n  @media(max-width: ", "px) {\n    font-size: 17px;\n    line-height: 22px;\n  }\n"])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE, LayoutConst.container.s);
export var ResultLabelBlock = styled(FlexBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 24px;\n\n  @media(max-width: ", "px) {\n    margin-top: 16px;\n  }\n\n  @media(max-width: ", "px) {\n    margin-top: 10px;\n  }\n"], ["\n  margin-top: 24px;\n\n  @media(max-width: ", "px) {\n    margin-top: 16px;\n  }\n\n  @media(max-width: ", "px) {\n    margin-top: 10px;\n  }\n"])), MEDIA_QUERY_MOBILE, LayoutConst.container.s);
export var VoteResultBlock = function (_a) {
    var votes = _a.votes, isMoreBlockFirst = _a.isMoreBlockFirst;
    var isMac13 = useBreakpoint(MEDIA_QUERY);
    var is568 = useBreakpoint(568);
    var smHeight = window.innerHeight < MEDIA_QUERY_HEIGHT;
    var language = useLocalization().language;
    var smSize = useMemo(function () { return (isMac13 || smHeight); }, [isMac13, smHeight]);
    var first = votes[0], second = votes[1];
    var blocksValues = useMemo(function () { return ({
        left: {
            width: (first === null || first === void 0 ? void 0 : first.percent) || 0,
            isMore: (first === null || first === void 0 ? void 0 : first.percent) > (second === null || second === void 0 ? void 0 : second.percent),
            count: (first === null || first === void 0 ? void 0 : first.count) || 0
        },
        right: {
            width: (second === null || second === void 0 ? void 0 : second.percent) || 0,
            isMore: (second === null || second === void 0 ? void 0 : second.percent) > (first === null || first === void 0 ? void 0 : first.percent),
            count: (second === null || second === void 0 ? void 0 : second.count) || 0
        }
    }); }, [first, second]);
    var isEqual = useMemo(function () { return ((blocksValues === null || blocksValues === void 0 ? void 0 : blocksValues.left.width) === (blocksValues === null || blocksValues === void 0 ? void 0 : blocksValues.right.width)); }, [blocksValues]);
    var blockLeftColor = useMemo(function () {
        var _a;
        return isEqual ? MORE_COLOR : ((_a = blocksValues === null || blocksValues === void 0 ? void 0 : blocksValues.left) === null || _a === void 0 ? void 0 : _a.isMore) ? MORE_COLOR : LESS_COLOR;
    }, [blocksValues]);
    var blockRightColor = useMemo(function () {
        var _a;
        return isEqual ? MORE_COLOR : ((_a = blocksValues === null || blocksValues === void 0 ? void 0 : blocksValues.right) === null || _a === void 0 ? void 0 : _a.isMore) ? MORE_COLOR : LESS_COLOR;
    }, [blocksValues]);
    var getSize = function (width) {
        if (isEqual)
            return 50;
        if (width === 100)
            return 100;
        if (width >= 87 && width <= 99)
            return 90;
        if (width >= 74 && width <= 86)
            return 70;
        if (width >= 62 && width <= 73)
            return 60;
        if (width >= 51 && width <= 61)
            return 51;
        if (width >= 39 && width <= 49)
            return 49;
        if (width >= 27 && width <= 38)
            return 40;
        if (width >= 14 && width <= 26)
            return 30;
        if (width >= 1 && width <= 13)
            return 10;
        if (width === 0)
            return 0;
    };
    var getBlockSize = function (_a) {
        var width = _a.width;
        return getSize(Number(width));
    };
    var getVotePercent = function (_a) {
        var width = _a.width;
        return Number(width);
    };
    return (React.createElement(FlexBox, { direction: "column", directionMobile: "column", width: "100%" },
        React.createElement(VoteResultWrapper, { gx: isMoreBlockFirst ? 24 : 0, gxMobile: isMoreBlockFirst ? (is568 ? '10px' : '16px') : 0, reverse: isMoreBlockFirst },
            React.createElement(LeftVoteResultBlock, { className: 'result-bar', "data-tip": blocksValues.left.count, blockWidth: getBlockSize(blocksValues.left), bg: blockLeftColor }, "".concat(getVotePercent(blocksValues.left), "%")),
            React.createElement(RightVoteResultBlock, { className: 'result-bar', "data-tip": blocksValues.right.count, reverse: isMoreBlockFirst, blockWidth: getBlockSize(blocksValues.right), bg: blockRightColor }, "".concat(getVotePercent(blocksValues.right), "%")),
            React.createElement(ReactTooltip, null)),
        React.createElement(ResultLabelBlock, { width: "100%", gx: 24 },
            React.createElement(ResultLabel, null, localizeTitle(first === null || first === void 0 ? void 0 : first.title, language)),
            React.createElement(ResultLabel, null, localizeTitle(second === null || second === void 0 ? void 0 : second.title, language)))));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=voteresultblock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from 'react';
import { LeftVoteResultBlock, RightVoteResultBlock, VoteResultWrapper } from './styles';
import { LayoutConst, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE } from '../../../../../constants/media';
import { FInter, FlexBox, useBreakpoint } from '@brg/ui';
import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import { localizeTitle } from "./voteradioblock";
import useLocalization from "../../../../../hooks/useLocalization";
export var MORE_COLOR = '#00BE00';
export var LESS_COLOR = '#E40000';
export var ResultLabel = styled(FInter.SmallTextBold)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: 'Inter';\n  width: 100%;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 42px;\n  line-height: 48px;\n  color: #fff;\n  white-space: wrap;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    font-size: 29px;\n    line-height: 39.5px;\n  }\n\n  @media(max-width: ", "px) {\n    font-size: 22px;\n    line-height: 28px;\n  }\n\n  @media(max-width: ", "px) {\n    font-size: 17px;\n    line-height: 22px;\n  }\n"], ["\n  font-family: 'Inter';\n  width: 100%;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 42px;\n  line-height: 48px;\n  color: #fff;\n  white-space: wrap;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    font-size: 29px;\n    line-height: 39.5px;\n  }\n\n  @media(max-width: ", "px) {\n    font-size: 22px;\n    line-height: 28px;\n  }\n\n  @media(max-width: ", "px) {\n    font-size: 17px;\n    line-height: 22px;\n  }\n"])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE, LayoutConst.container.s);
export var ResultLabelBlock = styled(FlexBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 24px;\n\n  @media(max-width: ", "px) {\n    margin-top: 16px;\n  }\n\n  @media(max-width: ", "px) {\n    margin-top: 10px;\n  }\n"], ["\n  margin-top: 24px;\n\n  @media(max-width: ", "px) {\n    margin-top: 16px;\n  }\n\n  @media(max-width: ", "px) {\n    margin-top: 10px;\n  }\n"])), MEDIA_QUERY_MOBILE, LayoutConst.container.s);
export var VoteResultBlock = function (_a) {
    var votes = _a.votes, isMoreBlockFirst = _a.isMoreBlockFirst;
    var isMac13 = useBreakpoint(MEDIA_QUERY);
    var is568 = useBreakpoint(568);
    var smHeight = window.innerHeight < MEDIA_QUERY_HEIGHT;
    var language = useLocalization().language;
    var smSize = useMemo(function () { return (isMac13 || smHeight); }, [isMac13, smHeight]);
    var first = votes[0], second = votes[1];
    var blocksValues = useMemo(function () { return ({
        left: {
            width: (first === null || first === void 0 ? void 0 : first.percent) || 0,
            isMore: (first === null || first === void 0 ? void 0 : first.percent) > (second === null || second === void 0 ? void 0 : second.percent),
            count: (first === null || first === void 0 ? void 0 : first.count) || 0
        },
        right: {
            width: (second === null || second === void 0 ? void 0 : second.percent) || 0,
            isMore: (second === null || second === void 0 ? void 0 : second.percent) > (first === null || first === void 0 ? void 0 : first.percent),
            count: (second === null || second === void 0 ? void 0 : second.count) || 0
        }
    }); }, [first, second]);
    var isEqual = useMemo(function () { return ((blocksValues === null || blocksValues === void 0 ? void 0 : blocksValues.left.width) === (blocksValues === null || blocksValues === void 0 ? void 0 : blocksValues.right.width)); }, [blocksValues]);
    var blockLeftColor = useMemo(function () {
        var _a;
        return isEqual ? MORE_COLOR : ((_a = blocksValues === null || blocksValues === void 0 ? void 0 : blocksValues.left) === null || _a === void 0 ? void 0 : _a.isMore) ? MORE_COLOR : LESS_COLOR;
    }, [blocksValues]);
    var blockRightColor = useMemo(function () {
        var _a;
        return isEqual ? MORE_COLOR : ((_a = blocksValues === null || blocksValues === void 0 ? void 0 : blocksValues.right) === null || _a === void 0 ? void 0 : _a.isMore) ? MORE_COLOR : LESS_COLOR;
    }, [blocksValues]);
    var getSize = function (width) {
        if (isEqual)
            return 50;
        if (width === 100)
            return 100;
        if (width >= 87 && width <= 99)
            return 90;
        if (width >= 74 && width <= 86)
            return 70;
        if (width >= 62 && width <= 73)
            return 60;
        if (width >= 51 && width <= 61)
            return 51;
        if (width >= 39 && width <= 49)
            return 49;
        if (width >= 27 && width <= 38)
            return 40;
        if (width >= 14 && width <= 26)
            return 30;
        if (width >= 1 && width <= 13)
            return 10;
        if (width === 0)
            return 0;
    };
    var getBlockSize = function (_a) {
        var width = _a.width;
        return getSize(Number(width));
    };
    var getVotePercent = function (_a) {
        var width = _a.width;
        return Number(width);
    };
    return (React.createElement(FlexBox, { direction: "column", directionMobile: "column", width: "100%" },
        React.createElement(VoteResultWrapper, { gx: isMoreBlockFirst ? 24 : 0, gxMobile: isMoreBlockFirst ? (is568 ? '10px' : '16px') : 0, reverse: isMoreBlockFirst },
            React.createElement(LeftVoteResultBlock, { className: 'result-bar', "data-tip": blocksValues.left.count, blockWidth: getBlockSize(blocksValues.left), bg: blockLeftColor }, "".concat(getVotePercent(blocksValues.left), "%")),
            React.createElement(RightVoteResultBlock, { className: 'result-bar', "data-tip": blocksValues.right.count, reverse: isMoreBlockFirst, blockWidth: getBlockSize(blocksValues.right), bg: blockRightColor }, "".concat(getVotePercent(blocksValues.right), "%")),
            React.createElement(ReactTooltip, null)),
        React.createElement(ResultLabelBlock, { width: "100%", gx: 24 },
            React.createElement(ResultLabel, null, localizeTitle(first === null || first === void 0 ? void 0 : first.title, language)),
            React.createElement(ResultLabel, null, localizeTitle(second === null || second === void 0 ? void 0 : second.title, language)))));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=voteresultblock.js.map